import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { reportesAPI } from '../services/api';

const Reportes = () => {
  const [activeTab, setActiveTab] = useState('ventas');
  const [loading, setLoading] = useState({});

  // Filtros Ventas
  const [filtrosVentas, setFiltrosVentas] = useState({
    fecha_desde: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
    fecha_hasta: new Date().toISOString().split('T')[0],
    estado: '',
    metodo_pago: ''
  });

  // Filtros CxC
  const [filtrosCxC, setFiltrosCxC] = useState({
    fecha_desde: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
    fecha_hasta: new Date().toISOString().split('T')[0],
    estado_cuenta: ''
  });

  // State para reportes profesionales
  const [ventasDiarias, setVentasDiarias] = useState(null);
  const [conciliacion, setConciliacion] = useState(null);
  const [agingCxC, setAgingCxC] = useState(null);
  const [estadoResultados, setEstadoResultados] = useState(null);
  const [reporteIVA, setReporteIVA] = useState(null);

  // Filtros Gastos
  const [filtrosGastos, setFiltrosGastos] = useState({
    fecha_desde: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().split('T')[0],
    fecha_hasta: new Date().toISOString().split('T')[0],
    estado: '',
    categoria_id: ''
  });

  // FIX: Delay revokeObjectURL to ensure the browser has time to start the download
  const descargarArchivo = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    // FIX: Revoke after 1s delay — immediate revoke can cancel download in some browsers
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 1000);
  };

  // FIX: Helper to extract error message from blob responses (API returns blob on error too)
  const extractBlobError = async (err) => {
    if (err.response?.data instanceof Blob) {
      try {
        const text = await err.response.data.text();
        const json = JSON.parse(text);
        return json.message || json.error || null;
      } catch { return null; }
    }
    return err.response?.data?.message || err.message || null;
  };

  // === VENTAS ===
  const exportarVentasExcel = async () => {
    setLoading(prev => ({ ...prev, ventasExcel: true }));
    try {
      const res = await reportesAPI.exportarVentasExcel(filtrosVentas);
      descargarArchivo(res.data, `reporte_ventas_${filtrosVentas.fecha_desde}_${filtrosVentas.fecha_hasta}.xlsx`);
      toast.success('Reporte de ventas Excel descargado');
    } catch (err) {
      console.error(err);
      // FIX: Extract meaningful error from blob response for user feedback
      const msg = await extractBlobError(err);
      toast.error(msg || 'Error al generar reporte Excel de ventas');
    } finally {
      setLoading(prev => ({ ...prev, ventasExcel: false }));
    }
  };

  const exportarVentasPDF = async () => {
    setLoading(prev => ({ ...prev, ventasPDF: true }));
    try {
      const res = await reportesAPI.exportarVentasPDF(filtrosVentas);
      descargarArchivo(res.data, `reporte_ventas_${filtrosVentas.fecha_desde}_${filtrosVentas.fecha_hasta}.pdf`);
      toast.success('Reporte de ventas PDF descargado');
    } catch (err) {
      console.error(err);
      // FIX: Extract meaningful error from blob response for user feedback
      const msg = await extractBlobError(err);
      toast.error(msg || 'Error al generar reporte PDF de ventas');
    } finally {
      setLoading(prev => ({ ...prev, ventasPDF: false }));
    }
  };

  // === CUENTAS POR COBRAR ===
  const exportarCxCExcel = async () => {
    setLoading(prev => ({ ...prev, cxcExcel: true }));
    try {
      const res = await reportesAPI.exportarCxCExcel(filtrosCxC);
      descargarArchivo(res.data, `reporte_cxc_${filtrosCxC.fecha_desde}_${filtrosCxC.fecha_hasta}.xlsx`);
      toast.success('Reporte CxC Excel descargado');
    } catch (err) {
      console.error(err);
      // FIX: Extract meaningful error from blob response for user feedback
      const msg = await extractBlobError(err);
      toast.error(msg || 'Error al generar reporte Excel de CxC');
    } finally {
      setLoading(prev => ({ ...prev, cxcExcel: false }));
    }
  };

  const exportarCxCPDF = async () => {
    setLoading(prev => ({ ...prev, cxcPDF: true }));
    try {
      const res = await reportesAPI.exportarCxCPDF(filtrosCxC);
      descargarArchivo(res.data, `reporte_cxc_${filtrosCxC.fecha_desde}_${filtrosCxC.fecha_hasta}.pdf`);
      toast.success('Reporte CxC PDF descargado');
    } catch (err) {
      console.error(err);
      // FIX: Extract meaningful error from blob response for user feedback
      const msg = await extractBlobError(err);
      toast.error(msg || 'Error al generar reporte PDF de CxC');
    } finally {
      setLoading(prev => ({ ...prev, cxcPDF: false }));
    }
  };

  // === GASTOS ===
  const exportarGastosExcel = async () => {
    setLoading(prev => ({ ...prev, gastosExcel: true }));
    try {
      const res = await reportesAPI.exportarGastosExcel(filtrosGastos);
      descargarArchivo(res.data, `reporte_gastos_${filtrosGastos.fecha_desde}_${filtrosGastos.fecha_hasta}.xlsx`);
      toast.success('Reporte de gastos Excel descargado');
    } catch (err) {
      console.error(err);
      // FIX: Extract meaningful error from blob response for user feedback
      const msg = await extractBlobError(err);
      toast.error(msg || 'Error al generar reporte Excel de gastos');
    } finally {
      setLoading(prev => ({ ...prev, gastosExcel: false }));
    }
  };

  const exportarGastosPDF = async () => {
    setLoading(prev => ({ ...prev, gastosPDF: true }));
    try {
      const res = await reportesAPI.exportarGastosPDF(filtrosGastos);
      descargarArchivo(res.data, `reporte_gastos_${filtrosGastos.fecha_desde}_${filtrosGastos.fecha_hasta}.pdf`);
      toast.success('Reporte de gastos PDF descargado');
    } catch (err) {
      console.error(err);
      // FIX: Extract meaningful error from blob response for user feedback
      const msg = await extractBlobError(err);
      toast.error(msg || 'Error al generar reporte PDF de gastos');
    } finally {
      setLoading(prev => ({ ...prev, gastosPDF: false }));
    }
  };

  // Shortcuts para rango rápido
  const setRangoRapido = (setFiltros, rango) => {
    const hoy = new Date();
    let desde, hasta;

    switch (rango) {
      case 'hoy':
        desde = hasta = hoy.toISOString().split('T')[0];
        break;
      case 'semana': {
        const dia = hoy.getDay();
        const lunes = new Date(hoy);
        lunes.setDate(hoy.getDate() - (dia === 0 ? 6 : dia - 1));
        desde = lunes.toISOString().split('T')[0];
        hasta = hoy.toISOString().split('T')[0];
        break;
      }
      case 'mes':
        desde = new Date(hoy.getFullYear(), hoy.getMonth(), 1).toISOString().split('T')[0];
        hasta = hoy.toISOString().split('T')[0];
        break;
      case 'mes_anterior': {
        const primerDiaMesAnt = new Date(hoy.getFullYear(), hoy.getMonth() - 1, 1);
        const ultimoDiaMesAnt = new Date(hoy.getFullYear(), hoy.getMonth(), 0);
        desde = primerDiaMesAnt.toISOString().split('T')[0];
        hasta = ultimoDiaMesAnt.toISOString().split('T')[0];
        break;
      }
      case 'trimestre': {
        const mesActual = hoy.getMonth();
        const inicioTrimestre = mesActual - (mesActual % 3);
        desde = new Date(hoy.getFullYear(), inicioTrimestre, 1).toISOString().split('T')[0];
        hasta = hoy.toISOString().split('T')[0];
        break;
      }
      case 'anio':
        desde = new Date(hoy.getFullYear(), 0, 1).toISOString().split('T')[0];
        hasta = hoy.toISOString().split('T')[0];
        break;
      default:
        return;
    }

    setFiltros(prev => ({ ...prev, fecha_desde: desde, fecha_hasta: hasta }));
  };

  const formatCurrency = (val) => {
    const num = parseFloat(val) || 0;
    return '$' + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  // FIX: Helper to format dates consistently with es-EC locale
  const formatDate = (dateStr) => {
    if (!dateStr) return '-';
    return new Date(dateStr).toLocaleDateString('es-EC');
  };

  // === REPORTES PROFESIONALES - Cargar datos ===
  const cargarVentasDiarias = async () => {
    setLoading(prev => ({ ...prev, ventasDiarias: true }));
    try {
      const fecha = filtrosVentas.fecha_hasta || new Date().toISOString().split('T')[0];
      const res = await reportesAPI.getVentasDiarias({ fecha });
      if (res.data.success) setVentasDiarias(res.data.data);
    } catch (e) {
      toast.error('Error al cargar resumen diario');
    } finally {
      setLoading(prev => ({ ...prev, ventasDiarias: false }));
    }
  };

  const cargarConciliacion = async () => {
    setLoading(prev => ({ ...prev, conciliacion: true }));
    try {
      const fecha = filtrosVentas.fecha_hasta || new Date().toISOString().split('T')[0];
      const res = await reportesAPI.getConciliacionCaja({ fecha });
      if (res.data.success) setConciliacion(res.data.data);
    } catch (e) {
      toast.error('Error al cargar conciliaci\u00f3n');
    } finally {
      setLoading(prev => ({ ...prev, conciliacion: false }));
    }
  };

  const cargarAgingCxC = async () => {
    setLoading(prev => ({ ...prev, agingCxC: true }));
    try {
      const res = await reportesAPI.getAgingCxC();
      if (res.data.success) setAgingCxC(res.data.data);
    } catch (e) {
      toast.error('Error al cargar aging CxC');
    } finally {
      setLoading(prev => ({ ...prev, agingCxC: false }));
    }
  };

  const cargarEstadoResultados = async () => {
    setLoading(prev => ({ ...prev, estadoResultados: true }));
    try {
      const params = {};
      if (filtrosVentas.fecha_desde) params.fecha_desde = filtrosVentas.fecha_desde;
      if (filtrosVentas.fecha_hasta) params.fecha_hasta = filtrosVentas.fecha_hasta;
      const res = await reportesAPI.getEstadoResultados(params);
      if (res.data.success) setEstadoResultados(res.data.data);
    } catch (e) {
      toast.error('Error al cargar estado de resultados');
    } finally {
      setLoading(prev => ({ ...prev, estadoResultados: false }));
    }
  };

  const cargarReporteIVA = async () => {
    setLoading(prev => ({ ...prev, reporteIVA: true }));
    try {
      const params = {};
      if (filtrosVentas.fecha_desde) params.fecha_desde = filtrosVentas.fecha_desde;
      if (filtrosVentas.fecha_hasta) params.fecha_hasta = filtrosVentas.fecha_hasta;
      const res = await reportesAPI.getReporteIVA(params);
      if (res.data.success) setReporteIVA(res.data.data);
    } catch (e) {
      toast.error('Error al cargar reporte IVA');
    } finally {
      setLoading(prev => ({ ...prev, reporteIVA: false }));
    }
  };

  // === REPORTES PROFESIONALES - Exportar Excel ===
  const exportarVentasDiariasExcel = async () => {
    setLoading(prev => ({ ...prev, ventasDiariasExcel: true }));
    try {
      const fecha = filtrosVentas.fecha_hasta || new Date().toISOString().split('T')[0];
      const res = await reportesAPI.exportarVentasDiariasExcel({ fecha });
      descargarArchivo(res.data, `ventas_diarias_${fecha}.xlsx`);
      toast.success('Reporte ventas diarias descargado');
    } catch (err) {
      console.error(err);
      // FIX: Extract meaningful error from blob response for user feedback
      const msg = await extractBlobError(err);
      toast.error(msg || 'Error al exportar ventas diarias');
    } finally {
      setLoading(prev => ({ ...prev, ventasDiariasExcel: false }));
    }
  };

  const exportarConciliacionExcel = async () => {
    setLoading(prev => ({ ...prev, conciliacionExcel: true }));
    try {
      const fecha = filtrosVentas.fecha_hasta || new Date().toISOString().split('T')[0];
      const res = await reportesAPI.exportarConciliacionExcel({ fecha });
      descargarArchivo(res.data, `conciliacion_caja_${fecha}.xlsx`);
      toast.success('Conciliaci\u00f3n de caja descargada');
    } catch (err) {
      console.error(err);
      // FIX: Extract meaningful error from blob response for user feedback
      const msg = await extractBlobError(err);
      toast.error(msg || 'Error al exportar conciliaci\u00f3n');
    } finally {
      setLoading(prev => ({ ...prev, conciliacionExcel: false }));
    }
  };

  const exportarAgingExcel = async () => {
    setLoading(prev => ({ ...prev, agingExcel: true }));
    try {
      const res = await reportesAPI.exportarAgingExcel();
      descargarArchivo(res.data, `aging_cxc_${new Date().toISOString().split('T')[0]}.xlsx`);
      toast.success('Aging CxC descargado');
    } catch (err) {
      console.error(err);
      // FIX: Extract meaningful error from blob response for user feedback
      const msg = await extractBlobError(err);
      toast.error(msg || 'Error al exportar aging CxC');
    } finally {
      setLoading(prev => ({ ...prev, agingExcel: false }));
    }
  };

  const exportarEstadoResultadosExcel = async () => {
    setLoading(prev => ({ ...prev, estadoResultadosExcel: true }));
    try {
      const params = {};
      if (filtrosVentas.fecha_desde) params.fecha_desde = filtrosVentas.fecha_desde;
      if (filtrosVentas.fecha_hasta) params.fecha_hasta = filtrosVentas.fecha_hasta;
      const res = await reportesAPI.exportarEstadoResultadosExcel(params);
      descargarArchivo(res.data, `estado_resultados_${filtrosVentas.fecha_desde}_${filtrosVentas.fecha_hasta}.xlsx`);
      toast.success('Estado de resultados descargado');
    } catch (err) {
      console.error(err);
      // FIX: Extract meaningful error from blob response for user feedback
      const msg = await extractBlobError(err);
      toast.error(msg || 'Error al exportar estado de resultados');
    } finally {
      setLoading(prev => ({ ...prev, estadoResultadosExcel: false }));
    }
  };

  const exportarIVAExcel = async () => {
    setLoading(prev => ({ ...prev, ivaExcel: true }));
    try {
      const params = {};
      if (filtrosVentas.fecha_desde) params.fecha_desde = filtrosVentas.fecha_desde;
      if (filtrosVentas.fecha_hasta) params.fecha_hasta = filtrosVentas.fecha_hasta;
      const res = await reportesAPI.exportarIVAExcel(params);
      descargarArchivo(res.data, `reporte_iva_${filtrosVentas.fecha_desde}_${filtrosVentas.fecha_hasta}.xlsx`);
      toast.success('Reporte IVA descargado');
    } catch (err) {
      console.error(err);
      // FIX: Extract meaningful error from blob response for user feedback
      const msg = await extractBlobError(err);
      toast.error(msg || 'Error al exportar reporte IVA');
    } finally {
      setLoading(prev => ({ ...prev, ivaExcel: false }));
    }
  };

  const RangoRapidoButtons = ({ setFiltros }) => (
    <div className="btn-group btn-group-sm mb-3">
      <button className="btn btn-outline-secondary" onClick={() => setRangoRapido(setFiltros, 'hoy')}>Hoy</button>
      <button className="btn btn-outline-secondary" onClick={() => setRangoRapido(setFiltros, 'semana')}>Esta Semana</button>
      <button className="btn btn-outline-secondary" onClick={() => setRangoRapido(setFiltros, 'mes')}>Este Mes</button>
      <button className="btn btn-outline-secondary" onClick={() => setRangoRapido(setFiltros, 'mes_anterior')}>Mes Anterior</button>
      <button className="btn btn-outline-secondary" onClick={() => setRangoRapido(setFiltros, 'trimestre')}>Trimestre</button>
      <button className="btn btn-outline-secondary" onClick={() => setRangoRapido(setFiltros, 'anio')}>Este Año</button>
    </div>
  );

  return (
    <div className="container-fluid">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="mb-1"><i className="bi bi-file-earmark-bar-graph me-2"></i>Centro de Reportes</h4>
          <p className="text-muted mb-0">Genera y descarga reportes en Excel y PDF</p>
        </div>
      </div>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-4">
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'ventas' ? 'active' : ''}`}
            onClick={() => setActiveTab('ventas')}
          >
            <i className="bi bi-cart-check me-1"></i> Ventas
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'cxc' ? 'active' : ''}`}
            onClick={() => setActiveTab('cxc')}
          >
            <i className="bi bi-wallet2 me-1"></i> Cuentas por Cobrar
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'gastos' ? 'active' : ''}`}
            onClick={() => setActiveTab('gastos')}
          >
            <i className="bi bi-receipt me-1"></i> Gastos / Egresos
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'ventas_diarias' ? 'active' : ''}`}
            onClick={() => setActiveTab('ventas_diarias')}
          >
            <i className="bi bi-calendar-day me-1"></i> Ventas del Día
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'conciliacion_caja' ? 'active' : ''}`}
            onClick={() => setActiveTab('conciliacion_caja')}
          >
            <i className="bi bi-cash-stack me-1"></i> Conciliación Caja
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'aging_cxc' ? 'active' : ''}`}
            onClick={() => setActiveTab('aging_cxc')}
          >
            <i className="bi bi-clock-history me-1"></i> Aging CxC
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'estado_resultados' ? 'active' : ''}`}
            onClick={() => setActiveTab('estado_resultados')}
          >
            <i className="bi bi-graph-up-arrow me-1"></i> Estado de Resultados
          </button>
        </li>
        <li className="nav-item">
          <button
            className={`nav-link ${activeTab === 'reporte_iva' ? 'active' : ''}`}
            onClick={() => setActiveTab('reporte_iva')}
          >
            <i className="bi bi-percent me-1"></i> Reporte IVA
          </button>
        </li>
      </ul>

      {/* ─── TAB VENTAS ─── */}
      {activeTab === 'ventas' && (
        <div className="card shadow-sm">
          <div className="card-header bg-success bg-opacity-10">
            <h5 className="mb-0 text-success"><i className="bi bi-cart-check-fill me-2"></i>Reporte de Ventas</h5>
          </div>
          <div className="card-body">
            <RangoRapidoButtons setFiltros={setFiltrosVentas} />

            <div className="row g-3 mb-4">
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha Desde</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosVentas.fecha_desde}
                  onChange={e => setFiltrosVentas(prev => ({ ...prev, fecha_desde: e.target.value }))}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha Hasta</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosVentas.fecha_hasta}
                  onChange={e => setFiltrosVentas(prev => ({ ...prev, fecha_hasta: e.target.value }))}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Estado</label>
                <select
                  className="form-select"
                  value={filtrosVentas.estado}
                  onChange={e => setFiltrosVentas(prev => ({ ...prev, estado: e.target.value }))}
                >
                  <option value="">Todos</option>
                  <option value="completada">Completada</option>
                  <option value="pendiente">Pendiente</option>
                  <option value="anulada">Anulada</option>
                </select>
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Método de Pago</label>
                <select
                  className="form-select"
                  value={filtrosVentas.metodo_pago}
                  onChange={e => setFiltrosVentas(prev => ({ ...prev, metodo_pago: e.target.value }))}
                >
                  <option value="">Todos</option>
                  <option value="efectivo">Efectivo</option>
                  <option value="tarjeta">Tarjeta</option>
                  <option value="transferencia">Transferencia</option>
                  <option value="credito">Crédito</option>
                  <option value="payphone">PayPhone</option>
                </select>
              </div>
            </div>

            <div className="d-flex gap-3">
              <button
                className="btn btn-success"
                onClick={exportarVentasExcel}
                disabled={loading.ventasExcel}
              >
                {loading.ventasExcel ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Generando...</>
                ) : (
                  <><i className="bi bi-file-earmark-excel me-2"></i>Descargar Excel</>
                )}
              </button>
              <button
                className="btn btn-danger"
                onClick={exportarVentasPDF}
                disabled={loading.ventasPDF}
              >
                {loading.ventasPDF ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Generando...</>
                ) : (
                  <><i className="bi bi-file-earmark-pdf me-2"></i>Descargar PDF</>
                )}
              </button>
            </div>

            <div className="mt-4 p-3 bg-light rounded">
              <h6 className="text-muted mb-2"><i className="bi bi-info-circle me-1"></i>Información del reporte</h6>
              <ul className="mb-0 small text-muted">
                <li>Incluye: Código, Fecha, Cliente, CI/RUC, Método Pago, Subtotal, IVA, Descuento, Total, Estado, Vendedor</li>
                <li>Totales generales calculados al final del reporte</li>
                <li>Filtros aplicados se muestran en el encabezado del documento</li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* ─── TAB CUENTAS POR COBRAR ─── */}
      {activeTab === 'cxc' && (
        <div className="card shadow-sm">
          <div className="card-header bg-danger bg-opacity-10">
            <h5 className="mb-0 text-danger"><i className="bi bi-wallet2 me-2"></i>Reporte de Cuentas por Cobrar</h5>
          </div>
          <div className="card-body">
            <RangoRapidoButtons setFiltros={setFiltrosCxC} />

            <div className="row g-3 mb-4">
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha Desde</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosCxC.fecha_desde}
                  onChange={e => setFiltrosCxC(prev => ({ ...prev, fecha_desde: e.target.value }))}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha Hasta</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosCxC.fecha_hasta}
                  onChange={e => setFiltrosCxC(prev => ({ ...prev, fecha_hasta: e.target.value }))}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Estado</label>
                <select
                  className="form-select"
                  value={filtrosCxC.estado_cuenta}
                  onChange={e => setFiltrosCxC(prev => ({ ...prev, estado_cuenta: e.target.value }))}
                >
                  <option value="">Todos</option>
                  <option value="pendiente">Pendiente</option>
                  <option value="parcial">Parcial</option>
                  <option value="vencida">Vencida</option>
                  <option value="pagada">Pagada</option>
                </select>
              </div>
            </div>

            <div className="d-flex gap-3">
              <button
                className="btn btn-success"
                onClick={exportarCxCExcel}
                disabled={loading.cxcExcel}
              >
                {loading.cxcExcel ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Generando...</>
                ) : (
                  <><i className="bi bi-file-earmark-excel me-2"></i>Descargar Excel</>
                )}
              </button>
              <button
                className="btn btn-danger"
                onClick={exportarCxCPDF}
                disabled={loading.cxcPDF}
              >
                {loading.cxcPDF ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Generando...</>
                ) : (
                  <><i className="bi bi-file-earmark-pdf me-2"></i>Descargar PDF</>
                )}
              </button>
            </div>

            <div className="mt-4 p-3 bg-light rounded">
              <h6 className="text-muted mb-2"><i className="bi bi-info-circle me-1"></i>Información del reporte</h6>
              <ul className="mb-0 small text-muted">
                <li>Incluye: Código Venta, Fecha, Cliente, CI/RUC, Celular, Total, Abonado, Saldo, Vencimiento, Estado, Días Vencido</li>
                <li>Totales generales: Total deuda, Total abonado, Saldo pendiente</li>
                <li>Las cuentas vencidas se destacan en el reporte</li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* ─── TAB GASTOS / EGRESOS ─── */}
      {activeTab === 'gastos' && (
        <div className="card shadow-sm">
          <div className="card-header bg-warning bg-opacity-10">
            <h5 className="mb-0 text-warning"><i className="bi bi-receipt me-2"></i>Reporte de Gastos / Egresos</h5>
          </div>
          <div className="card-body">
            <RangoRapidoButtons setFiltros={setFiltrosGastos} />

            <div className="row g-3 mb-4">
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha Desde</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosGastos.fecha_desde}
                  onChange={e => setFiltrosGastos(prev => ({ ...prev, fecha_desde: e.target.value }))}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha Hasta</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosGastos.fecha_hasta}
                  onChange={e => setFiltrosGastos(prev => ({ ...prev, fecha_hasta: e.target.value }))}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Estado</label>
                <select
                  className="form-select"
                  value={filtrosGastos.estado}
                  onChange={e => setFiltrosGastos(prev => ({ ...prev, estado: e.target.value }))}
                >
                  <option value="">Todos</option>
                  <option value="pendiente">Pendiente</option>
                  <option value="aprobado">Aprobado</option>
                  <option value="pagado">Pagado</option>
                  <option value="anulado">Anulado</option>
                </select>
              </div>
            </div>

            <div className="d-flex gap-3">
              <button
                className="btn btn-success"
                onClick={exportarGastosExcel}
                disabled={loading.gastosExcel}
              >
                {loading.gastosExcel ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Generando...</>
                ) : (
                  <><i className="bi bi-file-earmark-excel me-2"></i>Descargar Excel</>
                )}
              </button>
              <button
                className="btn btn-danger"
                onClick={exportarGastosPDF}
                disabled={loading.gastosPDF}
              >
                {loading.gastosPDF ? (
                  <><span className="spinner-border spinner-border-sm me-2"></span>Generando...</>
                ) : (
                  <><i className="bi bi-file-earmark-pdf me-2"></i>Descargar PDF</>
                )}
              </button>
            </div>

            <div className="mt-4 p-3 bg-light rounded">
              <h6 className="text-muted mb-2"><i className="bi bi-info-circle me-1"></i>Información del reporte</h6>
              <ul className="mb-0 small text-muted">
                <li>Incluye: Código, Fecha, Categoría, Concepto, Proveedor, Monto, Método Pago, # Documento, Estado</li>
                <li><i className="bi bi-people me-1"></i><strong>Trazabilidad:</strong> Solicitado por, Aprobado por, Pagado por (nombre del usuario responsable de cada acción)</li>
                <li>Total general de gastos calculado al final</li>
                <li>Gastos agrupados por categoría en el resumen</li>
              </ul>
            </div>
          </div>
        </div>
      )}

      {/* ─── TAB VENTAS DEL DIA ─── */}
      {activeTab === 'ventas_diarias' && (
        <div className="card shadow-sm">
          <div className="card-header bg-primary bg-opacity-10">
            <h5 className="mb-0 text-primary"><i className="bi bi-calendar-day me-2"></i>Ventas del Día - Resumen Diario</h5>
          </div>
          <div className="card-body">
            <div className="row g-3 mb-4 align-items-end">
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosVentas.fecha_hasta}
                  onChange={e => setFiltrosVentas(prev => ({ ...prev, fecha_hasta: e.target.value }))}
                />
              </div>
              <div className="col-md-6">
                <div className="d-flex gap-2">
                  <button className="btn btn-primary" onClick={cargarVentasDiarias} disabled={loading.ventasDiarias}>
                    {loading.ventasDiarias ? <><span className="spinner-border spinner-border-sm me-2"></span>Cargando...</> : <><i className="bi bi-search me-2"></i>Cargar</>}
                  </button>
                  <button className="btn btn-success" onClick={exportarVentasDiariasExcel} disabled={loading.ventasDiariasExcel}>
                    {loading.ventasDiariasExcel ? <><span className="spinner-border spinner-border-sm me-2"></span>Exportando...</> : <><i className="bi bi-file-earmark-excel me-2"></i>Exportar Excel</>}
                  </button>
                </div>
              </div>
            </div>

            {ventasDiarias && (
              <>
                {/* Summary Cards */}
                <div className="row g-3 mb-4">
                  <div className="col-md-4">
                    <div className="card border-primary">
                      <div className="card-body text-center">
                        <h6 className="text-muted mb-1">Total Ventas</h6>
                        <h3 className="text-primary mb-0">{formatCurrency(ventasDiarias.resumen?.total_ventas)}</h3>
                        {ventasDiarias.resumen?.desglose && (
                          <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                            Prod. {formatCurrency(ventasDiarias.resumen.desglose.productos?.total || 0)} · Serv. {formatCurrency(ventasDiarias.resumen.desglose.servicios?.total || 0)}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card border-info">
                      <div className="card-body text-center">
                        <h6 className="text-muted mb-1">Transacciones</h6>
                        <h3 className="text-info mb-0">{ventasDiarias.resumen?.num_transacciones || 0}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="card border-success">
                      <div className="card-body text-center">
                        <h6 className="text-muted mb-1">Ticket Promedio</h6>
                        <h3 className="text-success mb-0">{formatCurrency(ventasDiarias.resumen?.ticket_promedio)}</h3>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Por Cajero */}
                {ventasDiarias.por_cajero && ventasDiarias.por_cajero.length > 0 && (
                  <div className="mb-4">
                    <h6 className="fw-bold"><i className="bi bi-person-badge me-2"></i>Ventas por Cajero</h6>
                    <div className="table-responsive">
                      <table className="table table-sm table-striped table-bordered">
                        <thead className="table-dark">
                          <tr>
                            <th>Cajero</th>
                            {ventasDiarias.por_cajero.some(c => c.vendedor_nombre) && <th>Vendedor</th>}
                            <th className="text-center">Ventas</th>
                            <th className="text-end">Total</th>
                            <th className="text-end">Efectivo</th>
                            <th className="text-end">Tarjeta</th>
                            <th className="text-end">Transferencia</th>
                            <th className="text-end">Crédito</th>
                          </tr>
                        </thead>
                        <tbody>
                          {/* FIX: null safety — guard array access */}
                          {(ventasDiarias.por_cajero || []).map((c, i) => (
                            <tr key={i}>
                              <td>{c.cajero}</td>
                              {(ventasDiarias.por_cajero || []).some(x => x.vendedor_nombre) && (
                                <td>{c.vendedor_nombre ? <span className="badge bg-info bg-opacity-75">{c.vendedor_nombre}</span> : <span className="text-muted">-</span>}</td>
                              )}
                              <td className="text-center">{c.ventas}</td>
                              <td className="text-end">{formatCurrency(c.total)}</td>
                              <td className="text-end">{formatCurrency(c.efectivo)}</td>
                              <td className="text-end">{formatCurrency(c.tarjeta)}</td>
                              <td className="text-end">{formatCurrency(c.transferencia)}</td>
                              <td className="text-end">{formatCurrency(c.credito)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Por Metodo de Pago */}
                {ventasDiarias.por_metodo_pago && ventasDiarias.por_metodo_pago.length > 0 && (
                  <div className="mb-4">
                    <h6 className="fw-bold"><i className="bi bi-credit-card me-2"></i>Por Método de Pago</h6>
                    <div className="table-responsive">
                      <table className="table table-sm table-striped table-bordered">
                        <thead className="table-dark">
                          <tr>
                            <th>Método</th>
                            <th className="text-center">Cantidad</th>
                            <th className="text-end">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(ventasDiarias.por_metodo_pago || []).map((m, i) => (
                            <tr key={i}>
                              <td className="text-capitalize">{m.metodo}</td>
                              <td className="text-center">{m.cantidad}</td>
                              <td className="text-end">{formatCurrency(m.total)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Por Hora */}
                {ventasDiarias.por_hora && ventasDiarias.por_hora.length > 0 && (
                  <div className="mb-4">
                    <h6 className="fw-bold"><i className="bi bi-clock me-2"></i>Por Hora</h6>
                    <div className="table-responsive">
                      <table className="table table-sm table-striped table-bordered">
                        <thead className="table-dark">
                          <tr>
                            <th>Hora</th>
                            <th className="text-center">Cantidad</th>
                            <th className="text-end">Total</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(ventasDiarias.por_hora || []).map((h, i) => (
                            <tr key={i}>
                              <td>{String(h.hora).padStart(2, '0')}:00</td>
                              <td className="text-center">{h.cantidad}</td>
                              <td className="text-end">{formatCurrency(h.total)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {/* Actividad por Usuario */}
                {ventasDiarias.actividad_usuarios && ventasDiarias.actividad_usuarios.length > 0 && (
                  <div className="mb-4">
                    <h6 className="fw-bold"><i className="bi bi-people me-2"></i>Actividad por Usuario</h6>
                    <div className="table-responsive">
                      <table className="table table-sm table-striped table-bordered">
                        <thead className="table-dark">
                          <tr>
                            <th>Usuario</th>
                            <th className="text-center">Ventas</th>
                            <th className="text-end">Monto Ventas</th>
                            <th className="text-center">Cobros</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(ventasDiarias.actividad_usuarios || []).map((u, i) => (
                            <tr key={i}>
                              <td><i className="bi bi-person me-1"></i>{u.nombre_completo}</td>
                              <td className="text-center">{u.ventas_hoy}</td>
                              <td className="text-end">{formatCurrency(u.monto_ventas_hoy)}</td>
                              <td className="text-center">{u.cobros_hoy}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </>
            )}

            {!ventasDiarias && !loading.ventasDiarias && (
              <div className="text-center text-muted py-5">
                <i className="bi bi-calendar-day display-4"></i>
                <p className="mt-2">Seleccione una fecha y haga clic en "Cargar" para ver el resumen diario</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ─── TAB CONCILIACION CAJA ─── */}
      {activeTab === 'conciliacion_caja' && (
        <div className="card shadow-sm">
          <div className="card-header bg-info bg-opacity-10">
            <h5 className="mb-0 text-info"><i className="bi bi-cash-stack me-2"></i>Conciliación de Caja</h5>
          </div>
          <div className="card-body">
            <div className="row g-3 mb-4 align-items-end">
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosVentas.fecha_hasta}
                  onChange={e => setFiltrosVentas(prev => ({ ...prev, fecha_hasta: e.target.value }))}
                />
              </div>
              <div className="col-md-6">
                <div className="d-flex gap-2">
                  <button className="btn btn-info text-white" onClick={cargarConciliacion} disabled={loading.conciliacion}>
                    {loading.conciliacion ? <><span className="spinner-border spinner-border-sm me-2"></span>Cargando...</> : <><i className="bi bi-search me-2"></i>Cargar</>}
                  </button>
                  <button className="btn btn-success" onClick={exportarConciliacionExcel} disabled={loading.conciliacionExcel}>
                    {loading.conciliacionExcel ? <><span className="spinner-border spinner-border-sm me-2"></span>Exportando...</> : <><i className="bi bi-file-earmark-excel me-2"></i>Exportar Excel</>}
                  </button>
                </div>
              </div>
            </div>

            {conciliacion && conciliacion.cajas && conciliacion.cajas.length > 0 && (
              <div className="table-responsive">
                <table className="table table-sm table-striped table-bordered">
                  <thead className="table-dark">
                    <tr>
                      <th>Cajero</th>
                      <th>Código</th>
                      <th className="text-end">Apertura</th>
                      <th className="text-end">Ventas Efectivo</th>
                      <th className="text-end">Ingresos</th>
                      <th className="text-end">Retiros</th>
                      <th className="text-end">Esperado</th>
                      <th className="text-end">Real</th>
                      <th className="text-end">Diferencia</th>
                      <th className="text-center">Estado</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(conciliacion.cajas || []).map((caja, i) => {
                      const diff = parseFloat(caja.diferencia) || 0;
                      const isAlert = Math.abs(diff) > 2;
                      return (
                        <tr key={i}>
                          <td>{caja.cajero}</td>
                          <td>{caja.codigo}</td>
                          <td className="text-end">{formatCurrency(caja.apertura)}</td>
                          <td className="text-end">{formatCurrency(caja.ventas_efectivo)}</td>
                          <td className="text-end">{formatCurrency(caja.ingresos)}</td>
                          <td className="text-end">{formatCurrency(caja.retiros)}</td>
                          <td className="text-end">{formatCurrency(caja.esperado)}</td>
                          <td className="text-end">{formatCurrency(caja.real)}</td>
                          <td className={`text-end fw-bold ${isAlert ? 'text-danger' : 'text-success'}`}>
                            {formatCurrency(caja.diferencia)}
                          </td>
                          <td className="text-center">
                            <span className={`badge ${caja.estado === 'cerrada' ? 'bg-success' : 'bg-warning'}`}>
                              {caja.estado || 'abierta'}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                  {conciliacion.totales && (
                    <tfoot className="table-secondary fw-bold">
                      <tr>
                        <td colSpan="2">TOTALES</td>
                        <td className="text-end">{formatCurrency(conciliacion.totales.apertura)}</td>
                        <td className="text-end">{formatCurrency(conciliacion.totales.ventas_efectivo)}</td>
                        <td className="text-end">{formatCurrency(conciliacion.totales.ingresos)}</td>
                        <td className="text-end">{formatCurrency(conciliacion.totales.retiros)}</td>
                        <td className="text-end">{formatCurrency(conciliacion.totales.esperado)}</td>
                        <td className="text-end">{formatCurrency(conciliacion.totales.real)}</td>
                        <td className={`text-end ${Math.abs(parseFloat(conciliacion.totales.diferencia) || 0) > 2 ? 'text-danger' : 'text-success'}`}>
                          {formatCurrency(conciliacion.totales.diferencia)}
                        </td>
                        <td></td>
                      </tr>
                    </tfoot>
                  )}
                </table>
              </div>
            )}

            {!conciliacion && !loading.conciliacion && (
              <div className="text-center text-muted py-5">
                <i className="bi bi-cash-stack display-4"></i>
                <p className="mt-2">Seleccione una fecha y haga clic en "Cargar" para ver la conciliación</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ─── TAB AGING CxC ─── */}
      {activeTab === 'aging_cxc' && (
        <div className="card shadow-sm">
          <div className="card-header bg-danger bg-opacity-10">
            <h5 className="mb-0 text-danger"><i className="bi bi-clock-history me-2"></i>Aging Cuentas por Cobrar</h5>
          </div>
          <div className="card-body">
            <div className="d-flex gap-2 mb-4">
              <button className="btn btn-danger" onClick={cargarAgingCxC} disabled={loading.agingCxC}>
                {loading.agingCxC ? <><span className="spinner-border spinner-border-sm me-2"></span>Cargando...</> : <><i className="bi bi-search me-2"></i>Cargar</>}
              </button>
              <button className="btn btn-success" onClick={exportarAgingExcel} disabled={loading.agingExcel}>
                {loading.agingExcel ? <><span className="spinner-border spinner-border-sm me-2"></span>Exportando...</> : <><i className="bi bi-file-earmark-excel me-2"></i>Exportar Excel</>}
              </button>
            </div>

            {agingCxC && (
              <>
                {/* Summary Cards */}
                {agingCxC.resumen && (
                  <div className="row g-3 mb-4">
                    <div className="col">
                      <div className="card border-success">
                        <div className="card-body text-center py-2">
                          <small className="text-muted">Corriente</small>
                          <h5 className="text-success mb-0">{formatCurrency(agingCxC.resumen.corriente)}</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card border-warning">
                        <div className="card-body text-center py-2">
                          <small className="text-muted">1-30 días</small>
                          <h5 className="text-warning mb-0">{formatCurrency(agingCxC.resumen.dias_1_30)}</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card border-orange" style={{borderColor: '#fd7e14'}}>
                        <div className="card-body text-center py-2">
                          <small className="text-muted">31-60 días</small>
                          <h5 style={{color: '#fd7e14'}} className="mb-0">{formatCurrency(agingCxC.resumen.dias_31_60)}</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card border-danger">
                        <div className="card-body text-center py-2">
                          <small className="text-muted">61-90 días</small>
                          <h5 className="text-danger mb-0">{formatCurrency(agingCxC.resumen.dias_61_90)}</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col">
                      <div className="card border-dark">
                        <div className="card-body text-center py-2">
                          <small className="text-muted">90+ días</small>
                          <h5 className="text-dark mb-0">{formatCurrency(agingCxC.resumen.dias_90_plus)}</h5>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Aging Table */}
                {agingCxC.clientes && agingCxC.clientes.length > 0 && (
                  <div className="table-responsive">
                    <table className="table table-sm table-striped table-bordered">
                      <thead className="table-dark">
                        <tr>
                          <th>Cliente</th>
                          <th>CI/RUC</th>
                          <th className="text-center"># Facturas</th>
                          <th className="text-end">Total Pendiente</th>
                          <th className="text-end">Corriente</th>
                          <th className="text-end">1-30d</th>
                          <th className="text-end">31-60d</th>
                          <th className="text-end">61-90d</th>
                          <th className="text-end">90+d</th>
                        </tr>
                      </thead>
                      <tbody>
                        {(agingCxC.clientes || []).map((cli, i) => (
                          <tr key={i}>
                            <td>{cli.cliente}</td>
                            <td>{cli.ci_ruc}</td>
                            <td className="text-center">{cli.num_facturas}</td>
                            <td className="text-end fw-bold">{formatCurrency(cli.total_pendiente)}</td>
                            <td className="text-end">{formatCurrency(cli.corriente)}</td>
                            <td className="text-end">{formatCurrency(cli.dias_30)}</td>
                            <td className="text-end">{formatCurrency(cli.dias_60)}</td>
                            <td className="text-end">{formatCurrency(cli.dias_90)}</td>
                            <td className="text-end">{formatCurrency(cli.dias_120)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </>
            )}

            {!agingCxC && !loading.agingCxC && (
              <div className="text-center text-muted py-5">
                <i className="bi bi-clock-history display-4"></i>
                <p className="mt-2">Haga clic en "Cargar" para ver el aging de cuentas por cobrar</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ─── TAB ESTADO DE RESULTADOS ─── */}
      {activeTab === 'estado_resultados' && (
        <div className="card shadow-sm">
          <div className="card-header bg-dark bg-opacity-10">
            <h5 className="mb-0"><i className="bi bi-graph-up-arrow me-2"></i>Estado de Resultados (P&L)</h5>
          </div>
          <div className="card-body">
            <RangoRapidoButtons setFiltros={setFiltrosVentas} />

            <div className="row g-3 mb-4 align-items-end">
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha Desde</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosVentas.fecha_desde}
                  onChange={e => setFiltrosVentas(prev => ({ ...prev, fecha_desde: e.target.value }))}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha Hasta</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosVentas.fecha_hasta}
                  onChange={e => setFiltrosVentas(prev => ({ ...prev, fecha_hasta: e.target.value }))}
                />
              </div>
              <div className="col-md-6">
                <div className="d-flex gap-2">
                  <button className="btn btn-dark" onClick={cargarEstadoResultados} disabled={loading.estadoResultados}>
                    {loading.estadoResultados ? <><span className="spinner-border spinner-border-sm me-2"></span>Cargando...</> : <><i className="bi bi-search me-2"></i>Cargar</>}
                  </button>
                  <button className="btn btn-success" onClick={exportarEstadoResultadosExcel} disabled={loading.estadoResultadosExcel}>
                    {loading.estadoResultadosExcel ? <><span className="spinner-border spinner-border-sm me-2"></span>Exportando...</> : <><i className="bi bi-file-earmark-excel me-2"></i>Exportar Excel</>}
                  </button>
                </div>
              </div>
            </div>

            {estadoResultados && (
              <div className="border rounded p-4 bg-white">
                {/* INGRESOS */}
                <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">INGRESOS</h6>
                <div className="d-flex justify-content-between mb-1 ms-3">
                  <span>Ventas Brutas</span>
                  <span>{formatCurrency(estadoResultados.ingresos?.ventas_brutas)}</span>
                </div>
                <div className="d-flex justify-content-between mb-1 ms-3 text-danger">
                  <span>(-) Descuentos</span>
                  <span>- {formatCurrency(estadoResultados.ingresos?.descuentos)}</span>
                </div>
                <div className="d-flex justify-content-between mb-1 ms-3 text-danger">
                  <span>(-) Devoluciones</span>
                  <span>- {formatCurrency(estadoResultados.ingresos?.devoluciones)}</span>
                </div>
                {parseFloat(estadoResultados.ingresos?.servicios || 0) > 0 ? (
                  <>
                    <div className="d-flex justify-content-between fw-bold border-top pt-2 mt-2 mb-1">
                      <span>= Ventas Netas (productos)</span>
                      <span>{formatCurrency(estadoResultados.ingresos?.ventas_netas)}</span>
                    </div>
                    <div className="d-flex justify-content-between mb-1 ms-3 text-success">
                      <span>(+) Ingresos por Servicios</span>
                      <span>{formatCurrency(estadoResultados.ingresos?.servicios)}</span>
                    </div>
                    <div className="d-flex justify-content-between fw-bold border-top pt-2 mt-2 mb-4">
                      <span>= Ingresos Totales</span>
                      <span className="text-success">{formatCurrency(estadoResultados.ingresos?.ventas_totales)}</span>
                    </div>
                  </>
                ) : (
                  <div className="d-flex justify-content-between fw-bold border-top pt-2 mt-2 mb-4">
                    <span>= Ventas Netas</span>
                    <span>{formatCurrency(estadoResultados.ingresos?.ventas_netas)}</span>
                  </div>
                )}

                {/* COSTO DE VENTAS */}
                <h6 className="fw-bold text-warning border-bottom pb-2 mb-3">COSTO DE VENTAS</h6>
                <div className="d-flex justify-content-between mb-1 ms-3">
                  <span>Costo de Productos Vendidos</span>
                  <span>{formatCurrency(estadoResultados.costo_ventas?.costo_productos)}</span>
                </div>
                <div className="d-flex justify-content-between fw-bold border-top pt-2 mt-2 mb-4">
                  <span>= UTILIDAD BRUTA</span>
                  <span className="text-primary">{formatCurrency(estadoResultados.utilidad_bruta)}</span>
                </div>
                {estadoResultados.margen_bruto_pct !== undefined && (
                  <div className="text-end mb-4">
                    <span className="badge bg-primary">Margen Bruto: {(parseFloat(estadoResultados.margen_bruto_pct) || 0).toFixed(1)}%</span>
                  </div>
                )}

                {/* GASTOS OPERATIVOS */}
                <h6 className="fw-bold text-danger border-bottom pb-2 mb-3">GASTOS OPERATIVOS</h6>
                {/* El backend devuelve gastos_operativos como arreglo [{categoria,total}] + total_gastos */}
                {(Array.isArray(estadoResultados.gastos_operativos) ? estadoResultados.gastos_operativos : []).map((g, i) => (
                  <div className="d-flex justify-content-between mb-1 ms-3" key={i}>
                    <span>{g.categoria}</span>
                    <span>{formatCurrency(g.total)}</span>
                  </div>
                ))}
                <div className="d-flex justify-content-between fw-bold border-top pt-2 mt-2 mb-4">
                  <span>Total Gastos Operativos (caja chica)</span>
                  <span className="text-danger">{formatCurrency(estadoResultados.total_gastos)}</span>
                </div>

                {/* GASTOS DIARIOS (mig 048, separados de caja chica) */}
                <h6 className="fw-bold text-danger border-bottom pb-2 mb-3">GASTOS DIARIOS</h6>
                {(estadoResultados.gastos_diarios || []).map((g, i) => (
                  <div className="d-flex justify-content-between mb-1 ms-3" key={i}>
                    <span>{g.categoria}</span>
                    <span>{formatCurrency(g.total)}</span>
                  </div>
                ))}
                <div className="d-flex justify-content-between fw-bold border-top pt-2 mt-2 mb-1">
                  <span>Total Gastos Diarios</span>
                  <span className="text-danger">{formatCurrency(estadoResultados.total_gastos_diarios)}</span>
                </div>

                {/* UTILIDAD NETA */}
                <div className="d-flex justify-content-between fw-bold border-top border-3 border-dark pt-3 mt-4 fs-5">
                  <span>UTILIDAD NETA</span>
                  <span className={parseFloat(estadoResultados.utilidad_neta) >= 0 ? 'text-success' : 'text-danger'}>
                    {formatCurrency(estadoResultados.utilidad_neta)}
                  </span>
                </div>
                {estadoResultados.margen_neto_pct !== undefined && (
                  <div className="text-end mt-2">
                    <span className={`badge ${parseFloat(estadoResultados.margen_neto_pct) >= 0 ? 'bg-success' : 'bg-danger'}`}>
                      Margen Neto: {(parseFloat(estadoResultados.margen_neto_pct) || 0).toFixed(1)}%
                    </span>
                  </div>
                )}
              </div>
            )}

            {!estadoResultados && !loading.estadoResultados && (
              <div className="text-center text-muted py-5">
                <i className="bi bi-graph-up-arrow display-4"></i>
                <p className="mt-2">Seleccione un rango de fechas y haga clic en "Cargar" para ver el estado de resultados</p>
              </div>
            )}
          </div>
        </div>
      )}

      {/* ─── TAB REPORTE IVA ─── */}
      {activeTab === 'reporte_iva' && (
        <div className="card shadow-sm">
          <div className="card-header bg-secondary bg-opacity-10">
            <h5 className="mb-0 text-secondary"><i className="bi bi-percent me-2"></i>Reporte IVA</h5>
          </div>
          <div className="card-body">
            <RangoRapidoButtons setFiltros={setFiltrosVentas} />

            <div className="row g-3 mb-4 align-items-end">
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha Desde</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosVentas.fecha_desde}
                  onChange={e => setFiltrosVentas(prev => ({ ...prev, fecha_desde: e.target.value }))}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label fw-semibold">Fecha Hasta</label>
                <input
                  type="date"
                  className="form-control"
                  value={filtrosVentas.fecha_hasta}
                  onChange={e => setFiltrosVentas(prev => ({ ...prev, fecha_hasta: e.target.value }))}
                />
              </div>
              <div className="col-md-6">
                <div className="d-flex gap-2">
                  <button className="btn btn-secondary" onClick={cargarReporteIVA} disabled={loading.reporteIVA}>
                    {loading.reporteIVA ? <><span className="spinner-border spinner-border-sm me-2"></span>Cargando...</> : <><i className="bi bi-search me-2"></i>Cargar</>}
                  </button>
                  <button className="btn btn-success" onClick={exportarIVAExcel} disabled={loading.ivaExcel}>
                    {loading.ivaExcel ? <><span className="spinner-border spinner-border-sm me-2"></span>Exportando...</> : <><i className="bi bi-file-earmark-excel me-2"></i>Exportar Excel</>}
                  </button>
                </div>
              </div>
            </div>

            {reporteIVA && (
              <>
                {/* Summary Cards */}
                <div className="row g-3 mb-4">
                  <div className="col-md-3">
                    <div className="card border-primary">
                      <div className="card-body text-center">
                        <h6 className="text-muted mb-1"><i className="bi bi-arrow-up-circle me-1"></i>IVA Ventas (Generado)</h6>
                        <h3 className="text-primary mb-0">{formatCurrency(reporteIVA.resumen?.iva_ventas)}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card border-warning">
                      <div className="card-body text-center">
                        <h6 className="text-muted mb-1"><i className="bi bi-arrow-down-circle me-1"></i>IVA Compras</h6>
                        <h3 className="text-warning mb-0">{formatCurrency(reporteIVA.resumen?.iva_compras)}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card border-info">
                      <div className="card-body text-center">
                        <h6 className="text-muted mb-1"><i className="bi bi-receipt me-1"></i>IVA Gastos</h6>
                        <h3 className="text-info mb-0">{formatCurrency(reporteIVA.resumen?.iva_gastos)}</h3>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className={`card ${parseFloat(reporteIVA.resumen?.iva_por_pagar) >= 0 ? 'border-danger' : 'border-success'}`}>
                      <div className="card-body text-center">
                        <h6 className="text-muted mb-1"><i className="bi bi-calculator me-1"></i>IVA por Pagar</h6>
                        <h3 className={`mb-0 ${parseFloat(reporteIVA.resumen?.iva_por_pagar) >= 0 ? 'text-danger' : 'text-success'}`}>
                          {formatCurrency(reporteIVA.resumen?.iva_por_pagar)}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Detalle Table */}
                <div className="table-responsive">
                  <table className="table table-sm table-bordered">
                    <thead className="table-dark">
                      <tr>
                        <th>Concepto</th>
                        <th className="text-end">Base Imponible</th>
                        <th className="text-end">IVA</th>
                        <th className="text-end">Total</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reporteIVA.detalle?.ventas_con_iva && (
                        <tr>
                          <td><i className="bi bi-cart-check me-1 text-success"></i>Ventas con IVA</td>
                          <td className="text-end">{formatCurrency(reporteIVA.detalle.ventas_con_iva.base)}</td>
                          <td className="text-end text-primary fw-bold">{formatCurrency(reporteIVA.detalle.ventas_con_iva.iva)}</td>
                          <td className="text-end fw-bold">{formatCurrency(reporteIVA.detalle.ventas_con_iva.total)}</td>
                        </tr>
                      )}
                      {reporteIVA.detalle?.ventas_sin_iva && (
                        <tr>
                          <td><i className="bi bi-cart me-1 text-muted"></i>Ventas sin IVA (0%)</td>
                          <td className="text-end">{formatCurrency(reporteIVA.detalle.ventas_sin_iva.base)}</td>
                          {/* FIX: Use formatCurrency instead of hardcoded $0.00 for consistency */}
                          <td className="text-end">{formatCurrency(0)}</td>
                          <td className="text-end fw-bold">{formatCurrency(reporteIVA.detalle.ventas_sin_iva.total)}</td>
                        </tr>
                      )}
                      {reporteIVA.detalle?.compras_con_iva && (
                        <tr className="table-warning">
                          <td><i className="bi bi-bag me-1 text-warning"></i>Compras con IVA (Crédito Tributario)</td>
                          <td className="text-end">{formatCurrency(reporteIVA.detalle.compras_con_iva.base)}</td>
                          <td className="text-end text-warning fw-bold">{formatCurrency(reporteIVA.detalle.compras_con_iva.iva)}</td>
                          <td className="text-end fw-bold">{formatCurrency(reporteIVA.detalle.compras_con_iva.total)}</td>
                        </tr>
                      )}
                      {reporteIVA.detalle?.gastos_con_iva && parseFloat(reporteIVA.detalle.gastos_con_iva.iva) > 0 && (
                        <tr className="table-info">
                          <td><i className="bi bi-receipt me-1 text-info"></i>Gastos con IVA (Crédito Tributario)</td>
                          <td className="text-end">{formatCurrency(reporteIVA.detalle.gastos_con_iva.base)}</td>
                          <td className="text-end text-info fw-bold">{formatCurrency(reporteIVA.detalle.gastos_con_iva.iva)}</td>
                          <td className="text-end fw-bold">{formatCurrency(reporteIVA.detalle.gastos_con_iva.total)}</td>
                        </tr>
                      )}
                    </tbody>
                    <tfoot className="table-secondary fw-bold">
                      <tr>
                        <td>IVA POR PAGAR (Ventas - Compras - Gastos)</td>
                        <td></td>
                        <td className="text-end fs-5">{formatCurrency(reporteIVA.resumen?.iva_por_pagar)}</td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </>
            )}

            {!reporteIVA && !loading.reporteIVA && (
              <div className="text-center text-muted py-5">
                <i className="bi bi-percent display-4"></i>
                <p className="mt-2">Seleccione un rango de fechas y haga clic en "Cargar" para ver el reporte IVA</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Reportes;
